module.exports = __webpack_public_path__ + "static/media/eduprime_tulisan_hitam.fb566d32.png";